import * as React from 'react';

export default function ({ isUpdated }: { isUpdated: boolean }) {
  return isUpdated ? <i className="icon-deviation fontSmall whiteText" /> : null;
}
